export default function Content({ children }) {
  return children;
}

Content.type = Symbol('PageWithStaticHeader.Content');
